"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _copyright = _interopRequireDefault(require("@/components/copyright"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    iCopyright: _copyright.default
  },
  name: 'layoutFooter',
  data: function data() {
    return {};
  }
};